import { apiClient } from "../config";

async function getAllPortals(queryParams: any) {
  
  const res = await apiClient.get(`/admin/data-portals`, {
    params: queryParams,
  })
  return res.data;
}

export default getAllPortals;
